<template>
    <icon-button
        @click="menuToggle()"
        class="fixed left-4 top-[11px] md:top-5 block lg:hidden p-4 -m-4 lg:p-2 lg:-m-2"
    >
        <icon-base
            size="24"
            name="menu"
            title="Menu"
            class="text-app-font-grey-500 dark:text-app-font-grey-dark-500 hover:text-app-font-grey-600 dark:hover:text-app-font-grey-dark-600 focus:text-app-font-grey-600 dark:focus:text-app-font-grey-dark-600 active:text-app-font-grey-400 transition-colors duration-300 ease-in-out"
        />
    </icon-button>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import IconBase from '@/common/components/ui/icons/IconBase.vue'
import IconButton from '@/common/components/ui/icons/IconButton.vue'

export default defineComponent({
    name: 'MenuButton',
    components: {
        IconBase,
        IconButton,
    },
    setup() {
        const store = useStore()

        const menuState = computed(() => store.getters['ui/menuState'])

        const menuToggle = () => {
            if (menuState.value === 'opened') {
                store.dispatch('ui/setMenuState', 'closed')
            } else {
                store.dispatch('ui/setMenuState', 'opened')
            }
        }

        return {
            menuState,
            menuToggle,
        }
    },
})
</script>
